import {ConfigProvider, Select, Spin} from 'antd';
import Title from 'antd/es/typography/Title';

import {useEffect, useState, useRef} from 'react';
import {ClassesConnection, Classschool, PikaDoPartners} from '../graphql/API';
import {
  PaginatedSchoolsResponse,
  SchoolProfile,
} from '@PikaDoApp/npm-pikado-logic';

import {getCurrentUserPermission} from '../utils';
import {SchoolService} from '../modules/Schools/SchoolService';
import {SmileOutlined} from '@ant-design/icons';

const schoolService = new SchoolService();

type SchoolsDropDownProps = {
  onSelectSchool: (school: {id?: string; [key: string]: any}) => void;
  onSelectClass: (classschool?: {id?: string; [key: string]: any}) => void;
  onSelectPartner?: (partner: PikaDoPartners) => void;
};

export const SchoolsDropDown = ({
  onSelectSchool,
  onSelectClass,
  onSelectPartner,
}: SchoolsDropDownProps) => {
  const Timeout = useRef<any>();

  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [schools, setSchools] = useState<PaginatedSchoolsResponse>();
  const [classeschool, setClassesschool] = useState<ClassesConnection>();

  useEffect(() => {
    getCurrentUserPermission()
      .then(p => {
        if (p === 'admin') {
          searchSchools(0);
        } else {
          setIsLoading(false);
        }
      })
      .catch(er => {
        //console.log('err->', er);
      });
  }, []);

  const searchSchools = (offset: number, textSearch?: string) => {
    schoolService
      .getAllSchools(100, offset, textSearch)
      .then(resp => {
        setSchools(resp);

        setIsLoading(false);
      })
      .catch(error => {
        setIsLoading(false);
        //console.log('Error ->', error);
      });
  };
  const onScroll = event => {
    var target = event.target;
    if (
      !isLoading &&
      target.scrollTop + target.offsetHeight === target.scrollHeight &&
      (schools?.items?.length ?? 0) < (schools?.totalCount ?? 0)
    ) {
      setIsLoading(true);
      const offset = schools?.items?.length ?? 0;
      schoolService
        .getAllSchools(100, offset)
        .then(stds => {
          const currentItems = schools?.items ?? [];
          setSchools({
            ...stds,
            items: [...currentItems, ...stds.items],
          });
          setIsLoading(false);
        })
        .catch(error => {
          setIsLoading(false);
          //console.log('Error ->', error);
        });
    }
  };

  const customizeRenderEmpty = () => (
    <div style={{textAlign: 'center'}}>
      {isLoading ? (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      ) : (
        <>
          <SmileOutlined style={{fontSize: 20}} />
          <p>No Data</p>
        </>
      )}
    </div>
  );

  return (
    <>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <Select
          filterOption={false}
          notFoundContent={isLoading ? <Spin size="small" /> : null}
          showSearch
          onSearch={e => {
            setIsLoading(true);
            if (Timeout.current) {
              clearTimeout(Timeout.current);
            }
            Timeout.current = setTimeout(() => {
              searchSchools(0, e);
            }, 1100);
          }}
          style={{width: '100%'}}
          placeholder={'Select a school'}
          optionFilterProp="children"
          onPopupScroll={onScroll}
          loading={isLoading}
          onChange={(ID: any) => {
            //console.log('ONCHANEE', ID);
            onSelectClass(undefined);
            const id = ID;
            let selectedSchool = schools?.items?.find(
              (s: SchoolProfile & {id: string}) => s.id === id,
            );
            //console.log('ONCHANEE', selectedSchool);
            if (selectedSchool) {
              onSelectSchool(selectedSchool);
              if (onSelectPartner && (selectedSchool as any).partner) {
                onSelectPartner(
                  (selectedSchool as any).partner as PikaDoPartners,
                );
              }
            }
            setIsLoading(true);
            schoolService
              .getClassesBySchoolId(id)
              .then(classess => {
                setClassesschool(classess);
                setIsLoading(false);
              })
              .catch(error => {
                setIsLoading(false);
                //console.log('Error ->', error);
              });
          }}>
          {schools?.items?.map((std: SchoolProfile & {id: string}) => (
            <Select.Option key={std.id} value={std.id}>
              {std.name}
            </Select.Option>
          ))}
        </Select>

        <Select
          filterOption={false}
          notFoundContent={isLoading ? <Spin size="small" /> : null}
          showSearch
          onSearch={e => {
            setIsLoading(true);
            if (Timeout.current) {
              clearTimeout(Timeout.current);
            }
            Timeout.current = setTimeout(() => {
              searchSchools(0, e);
            }, 1100);
          }}
          style={{width: '100%'}}
          placeholder={'Select a class'}
          optionFilterProp="children"
          onPopupScroll={onScroll}
          loading={isLoading}
          onChange={(ID: any) => {
            const id = ID;
            let selectedClass = classeschool?.items?.find(
              (s: Classschool) => s.id === id,
            );

            onSelectClass(selectedClass as any);
          }}>
          {classeschool?.items?.map((clss: Classschool) => (
            <Select.Option key={clss.id} value={clss.id}>
              {clss.name}
            </Select.Option>
          ))}
        </Select>
      </ConfigProvider>

      {isError && <Title>Schools | Classess fetching error ⚠️</Title>}
    </>
  );
};
